module.exports = __webpack_public_path__ + "static/img/7.3de7de9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/7.png
// module id = x0ij
// module chunks = 0